import React from 'react';
import { Placing, PlayerOwnership } from '../../types/types';
import styled from '@emotion/styled';
import CaptainCard from '../Cards/CaptainCard';

export interface Props {
    placing: Placing;
    playerOwnership: PlayerOwnership;
}

const CardNumber = styled.b`
    font-size: 1.5rem;
    @media (min-width: 1024px) {
        font-size: 1.5rem ;
    }
`

const CardLabel = styled.span`
    font-size: 1rem;
    line-height: 1;
    @media (min-width: 1024px) {
        font-size: 1rem;
    }
`

const MetricsContainer = styled.div`
    display: flex;
    column-gap: 2rem;
    flex-wrap: wrap;
    @media(max-width: 800px) {
        flex-direction: row;
        justify-content: center;
        row-gap: 1rem;
        .rank-metric, .rd-metric {
            width: 40%;
        }
        .price-metric {
            width: 100%;
        }
    }
`

const SingleRoundHeading = ({placing,playerOwnership}:Props) => {
    let captain,vice = null;
    playerOwnership?.players.map(function(po) {
        if (po.played === 'capt') {
            captain = po.player;
        } else if (po.played == 'vice') {
            vice = po.player;
        }
    });

    let totalrank = placing?.position;
    let rdrank = placing?.round_position;
    let price = placing?.price;
    let price_change = placing?.price_change;
    return (<div style={{display: "flex"}}>
        <MetricsContainer >
            <div className="rank-metric" style={{display: "flex", flexDirection: "column", justifyContent: "center", alignItems: 'center'}}>
                <CardNumber>
                    {totalrank}
                </CardNumber>
                <CardLabel>Season Rank</CardLabel>
            </div>
            <div className="rd-metric" style={{display: "flex", flexDirection: "column", justifyContent: "center", alignItems: 'center'}}>
                <CardNumber>
                    {rdrank}
                </CardNumber>
                <CardLabel>Last Rd Rank</CardLabel>
            </div>
            <div className="price-metric" style={{display: "flex", flexDirection: "column", justifyContent: "center", alignItems: 'center'}}>
                <CardNumber style={{color: price_change > -1 ? 'green' : 'red'}}>
                    {price?.toLocaleString('en-US', { style: "currency", currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 0})}
                    &nbsp;({price_change > 0 ? '+' : ''}{price_change?.toLocaleString('en-US', { style: "currency", currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 0})})
                </CardNumber>
                <CardLabel>Price</CardLabel>
            </div>
            {captain ? <CaptainCard player={captain} played={'capt'} /> : '' }
            {vice ? <CaptainCard player={vice} played={"vice"} /> : "" }
        </MetricsContainer>
        
    </div>
    )
}

export default SingleRoundHeading;